<template>
    <b-modal
        no-fade
        ref="modalDelete"
        title-tag="h2"
        title="Delete Receipt"
        lazy
        @ok="proceedDelete"
    >
        Are you sure you want to permanently delete this receipt?
        <template v-slot:modal-footer="{ cancel }">
            <loader v-if="isDeleting" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="cancel"
                v-if="!isDeleting"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isDeleting"
                variant="primary"
                @click="proceedDelete"
            >
                Delete
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";

export default {
    components: {
        Loader
    },
    props: {
        receiptId: {
            type: [String, Number]
        }
    },
    data() {
        return {
            isDeleting: false
        };
    },
    methods: {
        open() {
            this.$refs.modalDelete.show();
        },
        async proceedDelete() {
            try {
                this.isDeleting = true;

                let res = await this.$http.delete(
                    `${process.env.BARRAMUNDI}inventory/receipt/${this.receiptId}`
                );

                if (
                    res.data.response &&
                    res.data.response.message &&
                    res.data.response.message.code === 200
                ) {
                    this._message("Receipt deleted");

                    setTimeout(() => {
                        this.$router.push({
                            name: "inventory_dashboard"
                        });
                    }, 500);
                } else {
                    throw new Error("Unable to delete receipt");
                }
            } catch (e) {
                this.isDeleting = false;
                this._message(e.message, "danger");
            }
        }
    }
};
</script>
